export default "__VITE_ASSET__Cg$b2pqZ__"